<script>
    import {onMount} from 'svelte';
    import { get, submit } from '../../utils.js';
    
    import {sgettext} from '../../i18n.js';
    import {PATH_PREFIX} from '../../apiUrls.js';
    
    import Button from '../Button.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import TaskListConfigurationDataTable from '../DataGrid/TaskListConfigurationDataTable.svelte';
    import D2BranchConfigurationForm from './D2BranchConfigurationForm.svelte';
    import D2ConfigurationStatusRenderer from './D2ConfigurationStatusRenderer.svelte';
    import D2FilterRenderer from './D2FilterRenderer.svelte';
    import D2FilterConfigurationForm from './D2FilterConfigurationForm.svelte';
    import D2CloneMetadataFiltersForm from './D2CloneMetadataFiltersForm.svelte';
    import Errors from '../Errors.svelte';

    export let branchId = null;

    let listUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-configuration-admin/`;
    let historyLogListUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-configuration-history-logs/`;
    let branchSettingUrl = `${PATH_PREFIX}/sw/instruction/d2/branch-setting/`; 

    let configurationForm;
    let deleteBranchConfiguration = "d2BranchConfigurationDelete";
    let filterConfigurationForm;
    let cloneMetadataFiltersForm;
    let requireReload = false;
    let refreshConfigs = false;
    let sending = false;
    let showHistoryLogs = false;
    let historyLogResults = [];
    let configs = [];
    let repositories = [];
    let activeRepoId = null;
    let editConfig = null;
    let deleteConfig = null;
    let filterConfig = null;
    $: formErrors = null;
    
    function handleNewConfiguration() {
        jQuery('#d2BranchConfigurationForm').modal('show');
    }
    function handleCloneMetadataFilters() {
        jQuery('#d2CloneMetadataFiltersForm').modal('show');
    }

    $: d2BranchConfigData = activeRepoId === null
        ? configs.map((r, index) => ({ ...r, index: index }))
        : configs.filter(r => r.d2_repository === activeRepoId).map((r, index) => ({ ...r, index: index }));

    $: d2ConfigHistoryLogs = historyLogResults.map((r, index) => ({ ...r, index: index }));

    let rowActions = {
        details: {
            label: sgettext('$$CONFIGURE_FILTERS$$'),
            iconClass: 'fas fa5-cog fa-fw',
            handler: (_, item) => {
                filterConfig = item;
                jQuery(`#d2BranchMetadataFilterConfigurationForm`).modal('show');
            }
        },
        edit: {
            label: sgettext('$$EDIT$$'),
            iconClass: 'fas fa5-pencil-alt fa-fw',
            handler: (_, item) => {
                editConfig = item;
                jQuery('#d2BranchConfigurationForm').modal('show');
            }
        },
        expire: {
            label: sgettext('$$EXPIRE$$'),
            iconClass: 'fas fa5-trash fa-fw',
            handler: (_, item) => {
                deleteConfig = item;
                jQuery(`#${deleteBranchConfiguration}`).modal('show');
            }
        }
    }

    let columns = {
        d2_repository: {
            label: sgettext('$$D2_REPOSITORY$$'),
            width: '10%'
        },
        status: {
            label: sgettext('$$STATUS$$'),
            width: '10%',
            renderer: D2ConfigurationStatusRenderer
        },
        branch_full_name: {
            label: sgettext('$$BRANCH$$'),
            width: '40%'
        },
        d2_filters: {
            label: sgettext('$$DOCUMENT_FILTERS$$'),
            width: '40%',
            renderer: D2FilterRenderer
        },
    }

    let historyLogColumns = {
        id: {
            label: sgettext('$$EVENT$$'),
            width: '5%'
        },
        subcategory: {
            label: sgettext('$$AUDIT_SUBCATEGORY$$'),
            width: '10%'
        },
        details: {
            label: sgettext('$$DETAILS$$'),
            width: '30%',
        },
        new_value: {
            label: sgettext('$$NEW_VALUE$$'),
            width: '20%',
        },
        full_name: {
            label: sgettext('$$USER$$'),
            width: '10%',
        },
        created_date: {
            label: sgettext('$$CREATED_DATE$$'),
            width: '20%',
            tooltip: sgettext('$$LAST_200_ENTRIES_DISPLAYED_ENTRIES_AUDIT$$'),
        },
    }

    async function deleteBranchConfig() {
        sending = true;
        const method = 'POST';
        let url = `${branchSettingUrl}`;
        try {
            deleteConfig.expired = true;
            const response = await submit(url, method, deleteConfig);

            if (!response.ok) {formErrors = sgettext('$$FAILED_EXPIRE_BRANCH_CONFIGURATION$$')};

            if (!formErrors || formErrors.length === 0) {
                hideDeleteModal();
                requireReload = true;
            }

        } catch (error) {
            formErrors = error?.message || (Object.keys(error || {}).length ? error : sgettext('$$FAILED_EXPIRE_BRANCH_CONFIGURATION$$'));
        }
        sending = false;
    }

    function hideDeleteModal () {
        deleteConfig = null;
        jQuery(`#${deleteBranchConfiguration}`).modal('hide');
    }

    async function fetchResults() {
        var url = `${listUrl}`;
        const resp = await get(url);
        const json = await resp.json();
        if (json) {
            configs = json['results'];
        }
    }
    
    async function fetchConfigResults(branchId) {
        if (!branchId) {console.error("branchId is null or undefined"); return;}
        var url = `${branchSettingUrl}?branch_id=${branchId}`;
        const resp = await get(url);
        const json = await resp.json();
        if (json) {
            repositories = json.d2_repositories.map(repo => ({id: repo[0], name: repo[1]}));
        }
    }

    async function fetchHistoryLogResults() {
        sending = true;
        const resp = await get(historyLogListUrl);
        const json = await resp.json();
        if (json) {
            historyLogResults = json.results
        }
        sending = false;
    }

    onMount(() => {
        fetchResults();
        fetchConfigResults(branchId);
    });

    $: {
        if (requireReload) {
            fetchResults();
            refreshConfigs = true;
            requireReload = false;
        }
    }


    $: {
        if (showHistoryLogs) {
            fetchHistoryLogResults();
        }
    }

</script>

<div class="d-flex justify-content-between align-items-center">
  <h1 class="text-primary">{sgettext('$$D2_CONFIGURATIONS$$')}</h1>
  <div>
    <Button
      type="secondary"
      name={sgettext('$$CLONE_METADATA_FILTERS_1$$')}
      on:click={handleCloneMetadataFilters}
    >
      <span slot="icon"><i class="fa fa-clone" /></span>
    </Button>
    <Button
      type="primary"
      name={sgettext('$$ADD_CONFIGURATION$$')}
      on:click={handleNewConfiguration}
    >
      <span slot="icon"><i class="fa fa-plus" /></span>
    </Button>
  </div>
</div>

<div>
  <ul class="nav nav-pills">
    <li class="nav-item">
      <a
        class="nav-link"
        class:active={!activeRepoId && !showHistoryLogs}
        on:click={() => ((activeRepoId = null), (showHistoryLogs = false))}
      >
        {sgettext('$$ALL$$')}
      </a>
    </li>
    {#each repositories as { id, name }}
      <li class="nav-item">
        <a
          class="nav-link"
          class:active={activeRepoId === id && !showHistoryLogs}
          on:click={() => ((activeRepoId = id), (showHistoryLogs = false))}
        >
          {name}
        </a>
      </li>
    {/each}
    <li class="nav-item" style="margin-left: auto;">
      <a
        class="nav-link"
        class:active={showHistoryLogs}
        on:click={() => (showHistoryLogs = !showHistoryLogs)}
      >
        {sgettext('$$HISTORY_LOGS$$')}
      </a>
    </li>
  </ul>
</div>
<br />

{#if showHistoryLogs}
  <TaskListConfigurationDataTable
    columns={historyLogColumns}
    rows={d2ConfigHistoryLogs}
    saving={sending}
    emptyLabel={sgettext('$$HISTORY_LOGS_FOUND$$')}
  />
{:else}
  <TaskListConfigurationDataTable
    {columns}
    rows={d2BranchConfigData}
    {rowActions}
    emptyLabel={sgettext('$$CONFIGURATIONS_FOUND$$')}
  />
{/if}

<D2BranchConfigurationForm
  bind:this={configurationForm}
  bind:requireReload
  {branchId}
  {editConfig}
/>

<D2CloneMetadataFiltersForm
  bind:this={cloneMetadataFiltersForm}
  bind:requireReload
  bind:refreshConfigs
  {branchId}
  {editConfig}
/>

<D2FilterConfigurationForm
  bind:this={filterConfigurationForm}
  bind:requireReload
  {branchId}
  {filterConfig}
/>

<ConfirmationModal
  id={deleteBranchConfiguration}
  title={sgettext('$$EXPIRE_CONFIRMATION$$')}
  onYes={deleteBranchConfig}
  onNo={hideDeleteModal}
  {sending}
>
  <div slot="message">
    {#if formErrors}
      <Errors errors={formErrors} />
    {/if}
    <div class="alert alert-warning">
      {sgettext(
        '$$WARNING_EXPIRING_CONFIGURATION_LEAVE$$'
      )}
    </div>
    <p>
      <strong>
        {sgettext(
          '$$SURE_WANT_EXPIRE_BRANCH_CONFIGURATION$$'
        )}
      </strong>
    </p>
  </div>
</ConfirmationModal>
